import React from 'react';
import './index.scss'

const HeatmapSolos = ({ title, yaxis, zaxis, xaxis }) => {
  return <div className='heatmap-container'>
    {/* <div className='title-legend'><h4>{title}</h4>{["Fungos", "Bactérias"].includes(title) ? getLegend() : getLegendPresent()}</div> */}
    <HeatmapComponent yaxis={yaxis} zaxis={zaxis} xaxis={xaxis} />
  </div>;
}

const getColor = (valor) => {
  if(valor === 100) {
    return "#0b7348"
  } else if(valor === 80){
    return "#41a67c"
  } else if(valor === 50) {
    return "#73cd57"
  } else if(valor === -1){
    return "#ff0102"
  } else {
    return "white"
  }
}

export const getLegend = () => {
  return <div className='legend'>
    <div><div className='color-item' style={{backgroundColor: getColor(100)}}></div>Ciclo do C, N e P</div>
    <div><div className='color-item' style={{backgroundColor: getColor(80)}}></div>Ciclo do S e Promotores do crescimento de plantas</div>
    <div><div className='color-item' style={{backgroundColor: getColor(50)}}></div>Controle biológico, resposta ao estresse e desnitrificação</div>
    <div><div className='color-item' style={{backgroundColor: getColor(-1)}}></div>Patógeno</div>
    <div><div className='color-item' style={{backgroundColor: '#fff' }}></div>Ausência</div>
  </div>
}

export const getLegendPresent = () => {
  return <div className='legend'>
    <div><div className='color-item' style={{backgroundColor: getColor(100)}}></div>Presença</div>
    <div><div className='color-item' style={{backgroundColor: "white"}}></div>Ausência</div>
  </div>
}

const HeatmapComponent = ({ yaxis, zaxis, xaxis }) => {
  return (
    <div style={{width: "auto"}}>
      <table cellSpacing={2}>
        <tbody>
          {yaxis.map((y, indexY) => <tr><td>{y}</td>{xaxis.map((x, indexX) => <td className='cell-heatmap' style={{ backgroundColor: getColor(zaxis[indexX][indexY]) }}>{""}</td>)}</tr>)}
        </tbody>
        <tfoot>
          <td></td>
          {xaxis.map(item => <td className='xaxis'>{item}</td>)}
        </tfoot>
      </table>
    </div>
  );
};

export default HeatmapSolos;